import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { RBACProvider } from "./contexts/RBACContext";

function App() {
  return (
    <AuthProvider>
      <RBACProvider>
        <Routes />
      </RBACProvider>
    </AuthProvider>
  );
}

export default App;
